import React from "react";

import "./index.scss";
import {useTranslation} from "react-i18next";

// Stato vuoto: una frase e, se serve, l'azione per riempirlo
function EmptyData({children, action}) {
	const {t} = useTranslation();

	return (
		<div className="empty-data-container">
			<div>{children || t("no_data")}</div>
			{action}
		</div>
	);
}

export default EmptyData;
